import BoxContainer from "./BoxContainer";
import Box from "@mui/material/Box";
import BoxHeading from "./BoxHeading";
import { Trans } from "react-i18next";
import Button from "@mui/material/Button";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import useRoutes, { getLinkComponentAttributes } from "../../hooks/useRoutes";
import { useAuth } from "../../providers/AuthProvider";
const useStyles = makeStyles((theme) => ({
    bottomContainer: {
        marginTop: theme.spacing(4),
    },
    heading: {
        fontSize: "20px",
        color: theme.palette.primary.dark + " !important",
        margin: 0,
    },
    loggedInText: {
        textAlign: "center",
    },
}));
const UserLoggedInBox = () => {
    const classes = useStyles();
    const routes = useRoutes();
    const { user } = useAuth();
    const myAccountProps = getLinkComponentAttributes("products.packages", routes);
    return (React.createElement(BoxContainer, { className: classes.bottomContainer },
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Box, { className: classes.loggedInText, flexGrow: 1 },
                React.createElement(BoxHeading, { className: classes.heading },
                    React.createElement(Trans, null, "Logged in")),
                user && React.createElement("div", null, user.name)),
            React.createElement(Button, Object.assign({ variant: "contained", color: "primary", size: "large", sx: {
                    minWidth: { xs: "96px", sm: "136px" },
                    px: 0,
                } }, myAccountProps),
                React.createElement(Trans, null, "My picture sets")))));
};
export default UserLoggedInBox;
